/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import HexGroup from 'solis/type/hex/group';


export default class HexFrontier
{
  constructor (group, filterCallback)
  {
    this.group = new HexGroup(group);

    this.frontier = group.getNeighborsWithFilter(filterCallback);

    this.distance = 1;
    this.filterCallback = filterCallback;
  }


  expand ()
  {
    this.group.append(this.frontier);

    this.frontier = this.frontier.getNeighborsWithExclude(this.group, this.filterCallback);

    ++this.distance;
  }


  size ()
  {
    return this.frontier.size();
  }


  empty ()
  {
    return this.frontier.empty();
  }


  getDistance ()
  {
    return this.distance;
  }


  *[Symbol.iterator]()
  {
    yield* this.frontier;
  }

};
